import * as types from '@/store/mutationTypes';
import { getActivityChecked } from '@/utils/getActivityChecked';
import activitiesService from '@/http/services/activitiesService';
import customFormService from '@/http/services/customFormService';
const SelectPaymentCardModal = () => import(/* webpackChunkName: "activities" */ '@/components/modals/SelectPaymentCardModal');
import { NotificationsTypes } from '@/constants/notificationsTypes';

export const actions = {
    getActivitiesInfo: async ({ commit }) => {
        const activitiesInfo = await activitiesService.getActivitiesInfo();

        const tmpActivitiesTab = [
            {
                tabName: activitiesInfo.classesTabName,
                componentName: 'ClassList',
                display: activitiesInfo.displayClasses
            },
            {
                tabName: activitiesInfo.campsTabName,
                componentName: 'CampsList',
                display: activitiesInfo.displayCamps
            },
            {
                tabName: activitiesInfo.aftercareTabName,
                componentName: 'AftercareList',
                display: activitiesInfo.displayAftercare
            },
            {
                tabName: 'Policies',
                componentName: 'Policies',
                display: true
            }
        ];

        commit(types.SET_ACTIVITIES_INFO, tmpActivitiesTab);
    },

    checkClassRoster: async (context, payload) => {
        try {
            const roster = await activitiesService.getClassRoster(payload);
            if (roster.joinStatus !== 'Invited') {
                
                context.dispatch('createNotification', {
                    message: 'The payment URL you are trying to access is no longer available.',
                    type: NotificationsTypes.ERROR
                });
                throw Error('The payment URL you are trying to access is no longer available.');
            }
        } catch (error) {
            throw error;
        }
    }, 
    checkCampRoster: async (context, payload) => {
        try {
            const status = await activitiesService.getCampRosterStatus(payload);   
            if (status !== 'Invited') {
                
                context.dispatch('createNotification', {
                    message: 'The payment URL you are trying to access is no longer available.',
                    type: NotificationsTypes.ERROR
                });
                throw Error('The payment URL you are trying to access is no longer available.');
            }
        } catch (error) {
            throw error;
        }
    }, 
    checkAftercareRoster: async (context, payload) => { 
        try {
            const roster =  await activitiesService.getAftercareRoster(payload.schoolId, payload.aftercareId, payload.rosterId, payload.rosterDayId, payload.childId);
            if (roster.joinStatus !== 'Invited') {
                
                context.dispatch('createNotification', {
                    message: 'The payment URL you are trying to access is no longer available.',
                    type: NotificationsTypes.ERROR
                });
                throw Error('The payment URL you are trying to access is no longer available.');
            }
        } catch (error) {
            throw error;
        }
    },

    getClassesBySchool: async ({ commit, dispatch, getters }) => {
        const ageList = getActivityChecked(getters.filters.ages);
        const gradeList = getActivityChecked(getters.filters.grades);
        const locationsList = getActivityChecked(getters.filters.locationIds);

        const options = {
            size: getters.pageSize,
            page: getters.pageNumber,
            locationIds: locationsList,
            ages: ageList,
            grades: gradeList,
            monday: getters.filters.monday,
            tuesday: getters.filters.tuesday,
            wednesday: getters.filters.wednesday,
            thursday: getters.filters.thursday,
            friday: getters.filters.friday,
            saturday: getters.filters.saturday,
            sunday: getters.filters.sunday,
            search: getters.searchQuery
        };

        const classes = await activitiesService.getClassesBySchool(options);

        const { pageable, totalPages, totalElements, numberOfElements } = classes;

        commit(types.SET_ACTIVITIES_CLASSES, classes);

        dispatch('configPagination', {
            ...pageable,
            numberOfElements,
            totalElements,
            totalPages,
            callback: () => {
                return dispatch('getClassesBySchool');
            }
        });
    },

    getCampsBySchool: async ({ commit, dispatch, getters }) => {
        const ageList = getActivityChecked(getters.filters.ages);
        const gradeList = getActivityChecked(getters.filters.grades);
        const locationsList = getActivityChecked(getters.filters.locationIds);

        const options = {
            size: getters.pageSize,
            page: getters.pageNumber,
            locationIds: locationsList,
            ages: ageList,
            grades: gradeList,
            monday: getters.filters.monday,
            tuesday: getters.filters.tuesday,
            wednesday: getters.filters.wednesday,
            thursday: getters.filters.thursday,
            friday: getters.filters.friday,
            saturday: getters.filters.saturday,
            sunday: getters.filters.sunday,
            search: getters.searchQuery
        };

        const camps = await activitiesService.getCampsBySchool(options);

        const { pageable, totalPages, totalElements, numberOfElements } = camps;

        commit(types.SET_ACTIVITIES_CAMPS, camps);

        dispatch('configPagination', {
            ...pageable,
            numberOfElements,
            totalElements,
            totalPages,
            callback: () => {
                return dispatch('getCampsBySchool');
            }
        });
    },

    getAftercareBySchool: async ({ commit, dispatch, getters }) => {
        const ageList = getActivityChecked(getters.filters.ages);
        const gradeList = getActivityChecked(getters.filters.grades);
        const locationsList = getActivityChecked(getters.filters.locationIds);

        const options = {
            size: getters.pageSize,
            page: getters.pageNumber,
            locationIds: locationsList,
            ages: ageList,
            grades: gradeList,
            monday: getters.filters.monday,
            tuesday: getters.filters.tuesday,
            wednesday: getters.filters.wednesday,
            thursday: getters.filters.thursday,
            friday: getters.filters.friday,
            saturday: getters.filters.saturday,
            sunday: getters.filters.sunday,
            search: getters.searchQuery
        };

        const aftercareSessions = await activitiesService.getAftercareBySchool(options);

        const { pageable, totalPages, totalElements, numberOfElements } = aftercareSessions;

        commit(types.SET_ACTIVITIES_AFTERCARE_SESSIONS, aftercareSessions);

        dispatch('configPagination', {
            ...pageable,
            numberOfElements,
            totalElements,
            totalPages,
            callback: () => {
                return dispatch('getAftercareBySchool');
            }
        })
    },


    getTeachers: async ({ commit }) => {
        const teachers = await activitiesService.getTeachers();

        commit(types.SET_TEACHERS, teachers);
    },

    getPickUpOptions: async ({ commit }) => {
        const pickUps = await activitiesService.getPickUpOptions();

        commit(types.SET_PICK_UP, pickUps);
    },

    getTShirtSizes: async ({ commit }) => {
        const tShirtSizes = await activitiesService.getTShirtSizes();

        commit(types.SET_T_SHIRT_SIZES, tShirtSizes);
    },

    getActivityExtras: async ({ commit }, payload) => {
        const activityExtras = await activitiesService.getActivityExtras(payload);

        commit(types.SET_ACTIVITY_EXTRAS, activityExtras);
    },

    getActivityExtrasCamp: async ({ commit }, payload) => {
        const activityExtrasCamp = await activitiesService.getActivityExtrasCamp(payload);

        commit(types.SET_ACTIVITY_EXTRAS_CAMP, activityExtrasCamp);
    },

    getActivityExtrasAftercare: async ({ commit }, payload) => {
        const activityExtrasAftercare = await activitiesService.getActivityExtrasAftercare(payload);

        commit(types.SET_ACTIVITY_EXTRAS_AFTERCARE, activityExtrasAftercare);
    },

    getActivityExtrasAftercareWhichUsesBefore: async ({ commit }, payload) => {
        const activityExtrasAftercareWhichUsesBefore = await activitiesService.getActivityExtrasAftercareUses(payload);

        commit(types.SET_ACTIVITY_EXTRAS_AFTERCARE_WHICH_USES_BEFORE, activityExtrasAftercareWhichUsesBefore);
    },

    getChildInfoForEnroll: async ({ commit }, payload) => {
        const childInfo = await activitiesService.getChildInfoForEnroll(payload);

        commit(types.SET_ACTIVITY_CHILD_ROSTER_INFO, childInfo);
    },

    getClassRequired: async ({ commit }, payload) => {
        const activitiesClassRequired = await activitiesService.getClassRequired(payload);

        commit(types.SET_ACTIVITIES_CLASS_REQUIRED, activitiesClassRequired);
    },

    getCampRequired: async ({ commit }, payload) => {
        const activitiesCampRequired = await activitiesService.getCampRequired(payload);

        commit(types.SET_ACTIVITIES_CAMP_REQUIRED, activitiesCampRequired);
    },

    getAftercareRequired: async ({ commit }, payload) => {
        const activitiesAftercareRequired = await activitiesService.getAftercareRequired(payload);

        commit(types.SET_ACTIVITIES_AFTERCARE_REQUIRED, activitiesAftercareRequired);
    },

    addToCart: async ({ dispatch, commit, getters }, payload) => {
        const isNewPaymentFlow = getters.schoolInfo && getters.schoolInfo.schoolFeatures && getters.schoolInfo.schoolFeatures["new-payments"];
        const res = await activitiesService.addToCart(payload);
        if (isNewPaymentFlow && Object.keys(res).length === 1 && Object.keys(res)[0] === 'id') {
            dispatch('setPayNowEnrollemtData', {
                activityId: payload.classId,
                childId: payload.form.childId,
                activityType: "Class"
            })
            dispatch('setPayNowActivityId', res.id);
            dispatch('openModal', {
                modal: SelectPaymentCardModal,
                options: {
                    confirmOnClose: true
                }
            });
        } else {
            dispatch('createNotification', { message: 'Added to cart' }); 
            dispatch('getClassesBySchool');
            commit(types.SET_SHOPPING_INDICATOR, true);
        }
    },

    addToWaitList: async ({ dispatch }, payload) => {
        await activitiesService.addToWaitList(payload);

        dispatch('createNotification', { message: 'Added to waitlist' });
        dispatch('getClassesBySchool');
    },

    addToCartCamp: async ({ dispatch, getters, commit }, payload) => {
        console.log({payload});
        
        const isNewPaymentFlow = getters.schoolInfo && getters.schoolInfo.schoolFeatures && getters.schoolInfo.schoolFeatures["new-payments"];
        const res = await activitiesService.addToCartCamp(payload);
        if (isNewPaymentFlow && Object.keys(res).length === 1 && Object.keys(res)[0] === 'id') {
            dispatch('setPayNowEnrollemtData', {
                activityId: payload.campPricingId,
                childId: payload.form.childId,
                activityType: "Camp"
            })
            dispatch('setPayNowActivityId', res.id);
            dispatch('openModal', {
                modal: SelectPaymentCardModal,
                options: {
                    confirmOnClose: true
                }
            });
        } else {
            dispatch('createNotification', { message: 'Added to cart' });
            dispatch('getCampsBySchool');
            commit(types.SET_SHOPPING_INDICATOR, true);
        }
    },

    addToWaitListCamp: async ({ dispatch }, payload) => {
        await activitiesService.addToWaitListCamp(payload);

        dispatch('createNotification', { message: 'Added to waitlist' });
        dispatch('getCampsBySchool');
    },

    addToCartAftercare: async ({ getters, dispatch, commit }, payload) => {
        const isNewPaymentFlow = getters.schoolInfo && getters.schoolInfo.schoolFeatures && getters.schoolInfo.schoolFeatures["new-payments"];
        const res = payload && payload.enrollTo === 'Rosters'
            ? await activitiesService.addToCartAftercareEnroll(payload)
            : await activitiesService.addToCartAftercareDropIn(payload);

        if (isNewPaymentFlow && res) {
            dispatch('setPayNowEnrollemtData', {
                activityId: payload.aftercareId,
                childId: payload.form.childId,
                activityType: payload.enrollTo === "Drop-in" ? "DropIn" : "Aftercare"
            })
            dispatch('setPayNowActivityId', Object.values(res)[0]);
            dispatch('openModal', {
                modal: SelectPaymentCardModal,
                options: {
                    confirmOnClose: true
                }
            });
        } else {
            dispatch('createNotification', { message: 'Added to cart' });
            dispatch('getAftercareBySchool');
            commit(types.SET_SHOPPING_INDICATOR, true);
        }
    },

    addToWaitListAftercare: async ({ dispatch }, payload) => {
        await activitiesService.addToWaitListAftercare(payload);

        dispatch('createNotification', { message: 'Added to waitlist' });
        dispatch('getAftercareBySchool');
    },

    getPolicies: async ({ commit }) => {
        const policies = await activitiesService.getPolicies();

        commit(types.SET_POLICIES, policies);
    },

    getFullDropInDates: async ({ commit }, payload) => {
        const fullDropInDates = await activitiesService.getAftercareFullDropInDates(payload);

        commit(types.SET_ACTIVITIES_AFTERCARE_DROP_IN_FULL, fullDropInDates);
    },

    // async checkClassStatus({ dispatch, commit, getters }, payload) {
    //     const ageList = getActivityChecked(getters.filters.ages);
    //     const gradeList = getActivityChecked(getters.filters.grades);
    //     const locationsList = getActivityChecked(getters.filters.locationIds);
    //     const oldStatus = payload.status;

    //     const options = {
    //         size: getters.pageSize,
    //         page: getters.pageNumber,
    //         locationIds: locationsList,
    //         ages: ageList,
    //         grades: gradeList,
    //         monday: getters.filters.monday,
    //         tuesday: getters.filters.tuesday,
    //         wednesday: getters.filters.wednesday,
    //         thursday: getters.filters.thursday,
    //         friday: getters.filters.friday,
    //         saturday: getters.filters.saturday,
    //         sunday: getters.filters.sunday,
    //         search: getters.searchQuery
    //     };

    //     const classes = await activitiesService.getClassesBySchool(options);
    //     const classToCheck = classes.content.find(activity => activity.id === payload.classId);

    //     if (classToCheck.status !== oldStatus) {
    //         dispatch('createNotification', { message: 'The activity status has been updated. Please refresh the page to view the most recent changes!', type: NotificationsTypes.ERROR });
    //         throw Error('The activity status has been updated. Please refresh the page to view the most recent changes!');
            
    //     }
    // },

    // checkCampStatus: async ({dispatch, commit, getters}, payload) => {
    //     const ageList = getActivityChecked(getters.filters.ages);
    //     const gradeList = getActivityChecked(getters.filters.grades);
    //     const locationsList = getActivityChecked(getters.filters.locationIds);
    //     const oldStatus = payload.status;

    //     const options = {
    //         size: getters.pageSize,
    //         page: getters.pageNumber,
    //         locationIds: locationsList,
    //         ages: ageList,
    //         grades: gradeList,
    //         monday: getters.filters.monday,
    //         tuesday: getters.filters.tuesday,
    //         wednesday: getters.filters.wednesday,
    //         thursday: getters.filters.thursday,
    //         friday: getters.filters.friday,
    //         saturday: getters.filters.saturday,
    //         sunday: getters.filters.sunday,
    //         search: getters.searchQuery
    //     };

    //     const camps = await activitiesService.getCampsBySchool(options);
    //     const campToCheck = camps.content.find(camp => camp.id === payload.campId);
    //     const campPricingToCheck = campToCheck.pricings.find(pricing => pricing.id === payload.campPricingId);

    //     if (campPricingToCheck.status !== oldStatus) {
    //         dispatch('createNotification', { message: 'The activity status has been updated. Please refresh the page to view the most recent changes!', type: NotificationsTypes.ERROR });
    //         throw Error('The activity status has been updated. Please refresh the page to view the most recent changes!');        } 
    // },

    getRostersFreeDays: async ({dispatch, commit, getters}, payload) => {
     
        const freeDays = await activitiesService.getAftercareRostersFreeDays(payload);

        if (freeDays.length === 0) {

            const ageList = getActivityChecked(getters.filters.ages);
            const gradeList = getActivityChecked(getters.filters.grades);
            const locationsList = getActivityChecked(getters.filters.locationIds);
            const oldStatus = payload.status;
    
            const options = {
                size: getters.pageSize,
                page: getters.pageNumber,
                locationIds: locationsList,
                ages: ageList,
                grades: gradeList,
                monday: getters.filters.monday,
                tuesday: getters.filters.tuesday,
                wednesday: getters.filters.wednesday,
                thursday: getters.filters.thursday,
                friday: getters.filters.friday,
                saturday: getters.filters.saturday,
                sunday: getters.filters.sunday,
                search: getters.searchQuery
            };
            
            const aftercareSessions = await activitiesService.getAftercareBySchool(options);

            if (aftercareSessions.content.length === 0) {
                dispatch('createNotification', { message: 'No available places left for the session!', type: NotificationsTypes.ERROR });
                return;
            }

            const session = aftercareSessions.content.find(session => session.id === payload.aftercareId);

            if (!session) {
                dispatch('createNotification', { message: 'No available places left for the session!', type: NotificationsTypes.ERROR });
                return;
            }

            const aftercareDay = session.days.find(day => day.id === payload.aftercareDayId);

            if (!aftercareDay) {
                dispatch('createNotification', { message: 'No available places left for the session!', type: NotificationsTypes.ERROR });
                return; 
            // }

            // if (aftercareDay.status !== oldStatus) {
            //     dispatch('createNotification', { message: 'The activity status has been updated. Please refresh the page to view the most recent changes!', type: NotificationsTypes.ERROR });
            } else {
                dispatch('createNotification', { message: 'No available places left for the session or this child is already enrolled to this activity!', type: NotificationsTypes.ERROR });
            }
        }
        commit(types.SET_ACTIVITIES_AFTERCARE_ROSTERS_FREE_DAYS, freeDays);
    },

    getWaitlistFreeDays: async ({ commit, dispatch }, payload) => {
        const freeDays = await activitiesService.getAftercareWaitlistFreeDays(payload);

        // const waitlistDay = freeDays.find(day => day.id === payload.aftercareDayId);

        // if (!waitlistDay) {
        //     dispatch('createNotification', { message: 'The activity status has been updated. Please refresh the page to view the most recent changes!', type: NotificationsTypes.ERROR });
        //     return;
        // } else {
            commit(types.SET_ACTIVITIES_AFTERCARE_WAITLIST_FREE_DAYS, freeDays);
        // }
    },

    getNotFilledCustomForms: async (context, payload) => {
        const userData = localStorage.getItem('user-info');
        const { userId } = JSON.parse(userData);
        const options = { ...payload, parentId: userId }
        const { data } = await customFormService.checkCustomForms(options);
        context.commit(types.UPDATE_CUSTOM_FORM, data);
    },

    checkChildBeforeToCart: async (context, payload) => {
        await activitiesService.checkChildBeforeToCart(payload);
    },

    checkChildBeforeCartCamp: async (context, payload) => {
        await activitiesService.checkChildBeforeCartCamp(payload);
    },

    checkChildBeforeAftercareEnroll: async (context, payload) => {
        await activitiesService.checkChildBeforeAftercareEnroll(payload);
    },

};


// WEBPACK FOOTER //
// ./src/store/modules/activities/actions.js